import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { FikaConcentrateAddressCardStackBackgroundViewModel } from './fika-concentrate-address-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fika-concentrate-address-card-stack-background',
  templateUrl: './fika-concentrate-address-card-stack-background.component.html',
  styleUrls: ['./fika-concentrate-address-card-stack-background.component.scss'],
  providers: [FikaConcentrateAddressCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FikaConcentrateAddressCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: FikaConcentrateAddressCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
